import React from 'react'

function Aktdivision() {
  return (
    <div className='bg-[#0C2341] container min-h-screen mt-20'>
      AKT DIVISION Page
    </div>
  )
}

export default Aktdivision
